import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout title="Politique cookies" lastUpdate="13 février 2026">
      <h2>1. Notre approche</h2>
      <p>Fripri respecte votre vie privée. Nous utilisons <strong>uniquement des cookies essentiels</strong> au fonctionnement du site. Aucun cookie de publicité, de tracking marketing, ou de partage avec des tiers à des fins commerciales.</p>

      <h2>2. Cookies utilisés</h2>
      <table>
        <thead>
          <tr><th>Cookie</th><th>Finalité</th><th>Durée</th><th>Type</th></tr>
        </thead>
        <tbody>
          <tr>
            <td><code>access_token</code></td>
            <td>Authentification (vous garder connecté)</td>
            <td>7 jours</td>
            <td>Essentiel</td>
          </tr>
          <tr>
            <td><code>session_token</code></td>
            <td>Connexion via Google (si utilisée)</td>
            <td>7 jours</td>
            <td>Essentiel</td>
          </tr>
          <tr>
            <td><code>fripri_cookie_consent</code></td>
            <td>Mémoriser votre choix sur ce bandeau</td>
            <td>12 mois</td>
            <td>Essentiel</td>
          </tr>
        </tbody>
      </table>

      <h2>3. Stockage local (localStorage)</h2>
      <p>Votre jeton d’authentification est stocké exclusivement dans un cookie sécurisé <code>httpOnly</code>, inaccessible aux scripts. Le stockage local du navigateur (<code>localStorage</code>) ne conserve qu’un simple indicateur de session et vos préférences d’affichage (bandeau cookies, bannière d’installation). Ces données sont strictement essentielles au fonctionnement et ne sont jamais transmises à des tiers.</p>

      <h2>4. Aucun cookie tiers de marketing</h2>
      <p>Nous n’utilisons pas :</p>
      <ul>
        <li>Google Analytics, Google Tag Manager</li>
        <li>Facebook Pixel, Meta Ads</li>
        <li>TikTok, Snapchat, ou autres trackers publicitaires</li>
        <li>Hotjar, FullStory, ou autres outils de session replay</li>
      </ul>
      <p>Si nous ajoutons un jour un outil d’analytique, nous mettrons à jour cette politique et vous demanderons votre consentement préalable.</p>

      <h2>5. Cookies tiers (sous-traitants)</h2>
      <p>Lorsque vous payez via Stripe, Stripe peut déposer ses propres cookies sur sa page de paiement sécurisée. Ces cookies sont régis par la <a href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noreferrer">politique cookies de Stripe</a> et sont essentiels au traitement du paiement.</p>

      <h2>6. Notifications push</h2>
      <p>Les notifications push ne sont pas des cookies. Elles utilisent le protocole Web Push Protocol (VAPID) et nécessitent votre <strong>consentement explicite</strong> via la fenêtre de votre navigateur. Vous pouvez les désactiver à tout moment dans les paramètres de votre navigateur ou de votre Tableau de bord Fripri.</p>

      <h2>7. Comment gérer les cookies ?</h2>
      <p>Vous pouvez à tout moment :</p>
      <ul>
        <li>Bloquer ou supprimer les cookies via les paramètres de votre navigateur</li>
        <li>Naviguer en mode privé / incognito (les cookies sont supprimés à la fermeture)</li>
        <li>Vous déconnecter de Fripri (cela supprime les cookies d’authentification)</li>
      </ul>
      <p>⚠️ Désactiver les cookies essentiels rendra Fripri non fonctionnel (impossible de se connecter, de mettre des articles au panier, etc.).</p>

      <h2>8. Liens utiles par navigateur</h2>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer">Chrome</a></li>
        <li><a href="https://support.mozilla.org/fr/kb/protection-renforcee-contre-pistage-firefox-ordinateur" target="_blank" rel="noreferrer">Firefox</a></li>
        <li><a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer">Safari</a></li>
        <li><a href="https://support.microsoft.com/fr-fr/microsoft-edge" target="_blank" rel="noreferrer">Edge</a></li>
      </ul>

      <h2>9. Contact</h2>
      <p>Pour toute question : <a href="mailto:direction@fripri.com">direction@fripri.com</a></p>
    </LegalLayout>
  );
}
